import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import i18n from './i18n';
import tenantState, { refreshTenant } from './tenant';

// Axios 인터셉터 설정
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  console.log("Get token");
  if (config.url === '/api/login' || config.url === '/api/register') {
    return config;
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  console.log("token err");
  return Promise.reject(error);
});

// API 기준 주소: 빌드 시 VUE_APP_API_BASE (비우면 웹을 서빙하는 서버와 같은 origin → 온프레미스 기본)
axios.defaults.baseURL = process.env.VUE_APP_API_BASE || '';

// 게이트웨이 WebSocket(웹 클라이언트 모드) 주소: VUE_APP_WS_URL 우선, 없으면 현재 호스트 + VUE_APP_WS_PORT(기본 5102)
let wsUrl = process.env.VUE_APP_WS_URL || '';
if (!wsUrl) {
  const host = axios.defaults.baseURL ? new URL(axios.defaults.baseURL).hostname : window.location.hostname;
  const proto = window.location.protocol === 'https:' && !axios.defaults.baseURL ? 'wss' : 'ws';
  wsUrl = `${proto}://${host}:${process.env.VUE_APP_WS_PORT || 5102}`;
}

const app = createApp(App);
app.config.globalProperties.$wsUrl = wsUrl;

// 라우터 가드: 매 이동마다 서버를 기다리지 않고, 캐시로 먼저 이동 후 백그라운드에서 갱신
router.beforeEach((to, from, next) => {
  refreshTenant();
  if (to.path === '/') {
    next();
    return;
  }
  const token = localStorage.getItem('token');
  if (!token || to.path === '/change-password') {
    next();
    return;
  }
  const cached = localStorage.getItem('isadmin');
  if (cached !== null && cached !== '') {
    app.config.globalProperties.$isadmin = parseInt(cached, 10);
  }
  next();
  axios.get('/api/checkadmin').then((res) => {
    const isadmin = res.data.isadmin;
    app.config.globalProperties.$isadmin = isadmin;
    localStorage.setItem('isadmin', String(isadmin));
  }).catch(() => {});
});

// 플러그인 등록
app.use(router);
app.use(i18n);

// Vue 인스턴스 생성 전에
app.config.globalProperties.$company = localStorage.getItem('company') || '';
// 테넌트 프리셋 (layout · homeRoute · wards …) — packages/tenant-config
Object.defineProperty(app.config.globalProperties, '$tenant', { get: () => tenantState.tenant });

// localStorage가 변경될 때마다 $company 업데이트
window.addEventListener('storage', (event) => {
  if (event.key === 'company') {
    app.config.globalProperties.$company = event.newValue || '';
    refreshTenant();
  }
});

app.mount('#app');
